import type { FC } from 'react';

import Button, { ButtonAppearance } from 'bloko/blocks/button';
import Column from 'bloko/blocks/column';
import Conversion from 'bloko/blocks/conversion';
import Modal, { ModalFooter, ModalHeader, ModalTitle } from 'bloko/blocks/modal';
import Text, { TextImportance } from 'bloko/blocks/text';

import useTrls from 'hooks/translation/useTrls';

import styles from 'components/CampaignCard/CampaignInfo/Targetings/Regions/AdditionalRegionsModal/AdditionalRegionsModal.module.less';

interface Props {
    visible: boolean;
    setVisible: (payload: boolean) => unknown;
    titleKey: string;
    areas: {
        include: string[];
        exclude: string[];
    };
    closeKey: string;
}

const AreasColumn: FC<{ items: string[]; type: 'include' | 'exclude' }> = ({ items, type }) => {
    const trls = useTrls();

    return (
        <Column xs="1" s="2" m="3" l="4" className={styles.item}>
            <Text importance={TextImportance.Tertiary}>
                <Conversion
                    zero={trls(`campaign.targetings.regions.modal.${type}.zero`)}
                    one={trls(`campaign.targetings.regions.modal.${type}.one`)}
                    some={trls(`campaign.targetings.regions.modal.${type}.some`)}
                    many={trls(`campaign.targetings.regions.modal.${type}.many`)}
                    value={items.length}
                />
            </Text>

            <div>{items.join(', ')}</div>
        </Column>
    );
};

const AdditionalRegionsModal: FC<Props> = ({ areas, setVisible, visible, closeKey, titleKey }) => {
    const trls = useTrls();

    return (
        <Modal visible={visible} onClose={() => setVisible(false)}>
            <ModalHeader>
                <ModalTitle>{trls(titleKey)}</ModalTitle>
            </ModalHeader>

            <section className={styles.wrapper}>
                <AreasColumn type="include" items={areas.include} />
                {Boolean(areas.exclude.length) && <AreasColumn type="exclude" items={areas.exclude} />}
            </section>

            <ModalFooter>
                <Button appearance={ButtonAppearance.Outlined} onClick={() => setVisible(false)}>
                    {trls(closeKey)}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default AdditionalRegionsModal;
